/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CategoryUpdateSubCategoryResponse } from './CategoryUpdateSubCategoryResponse';

export type CategoryUpdateSubCategoryResponseApiRespoonse = {
    data?: CategoryUpdateSubCategoryResponse;
    status?: CategoryUpdateSubCategoryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CategoryUpdateSubCategoryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

